.swiper {
  height: var(--images-height, 260px);
}

.swiper > a {
  display: block;
  height: 100%;
}

.swiper > img,
.swiper > a > img {
  height: 100%;
}

.image a,
.image > img {
  height: 100%;
  box-sizing: border-box;
}

.image a {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image > img {
  display: block;
  margin: 0 auto;
}

.image img {
  max-width: calc(100% - 16px);
  max-height: 100%;
  object-fit: contain;
}

.fullWidth a,
.fullWidth .image > img {
  width: 100%;
}

.fullWidth .image {
  width: 100%;
}

.fullWidth .image img {
  width: 100%;
  max-width: 100%;
  object-fit: cover;
}

@media (--view-md) {
  .swiper {
    height: var(--images-height, 425px);
  }
}

.imagePlaceholder {
  width: 100%;
  height: 260px;
  background-color: var(--color-primary);
}

@media (--view-md) {
  .imagePlaceholder {
    height: 425px;
  }
}
